import { z } from "zod";

/** The member the office picks by hand for a Personio person the sync could not match. */
export const personioLinkMemberFormSchema = z.object({
	userId: z.string().min(1),
});

export type PersonioLinkMemberFormSchema = z.infer<typeof personioLinkMemberFormSchema>;
